// @flow

import { combineReducers } from 'redux';
import { home } from 'home-page';
import { search } from 'search-page';
import { specialistPage } from 'specialist-page';
import { practicePage } from 'practice-page';
import globalRedux from 'doctify-global-redux';
import { routerReducer as routing } from 'react-router-redux';
import { routerReducer } from 'react-router-redux';
import { reducer as session } from 'redux-simple-auth';
import { login } from 'login-page';
import { errorPage } from 'error-page';

const global = globalRedux.global;

export default combineReducers({
	global,
	home,
	login,
	search,
	session,
	routing,
	routerReducer,
	specialistPage,
	practicePage,
    errorPage
});



// WEBPACK FOOTER //
// ./src/client/root-reducer.js